module.exports = __webpack_public_path__ + "static/media/logo-full-color.3b8c0e56.png";